import { createRoute } from "../../../utils";

import { journalPapersRoutesObj, journalPaperBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const journalPapersRouteMetadata: IRouteMetadataObj<
  typeof journalPapersRoutesObj
> = {
  list: {
    title: "journalPapersList",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/journalPaper/table/page"
      ),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewPaper",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/journalPaper/form/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editPaperOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/journalPaper/form/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewPaperOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/articlesAndBook/journalPaper/form/page"
      ),
    mode: "view",
    permission,
  },
};

export const journalPapersRoutes = createRoute<typeof journalPapersRoutesObj>(
  journalPapersRoutesObj,
  journalPapersRouteMetadata,
  journalPaperBreadcrumbs,
);
